export default __webpack_public_path__ + "static/media/italic.b401a65e.svg";